import * as _ from 'lodash';
import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { BlendFontFamily, colors, combineStyles, fonts, mixins } from '@blend/consumer-components';

import * as deploymentConfig from 'login-utils/deploymentConfig';

const styles = StyleSheet.create({
  base: combineStyles(mixins.padding(14, 16), mixins.margin(0, 'auto'), mixins.borderRadius(4), {
    backgroundColor: deploymentConfig.getOrganizationColors().action,
    border: 0,
    color: colors.white,
    cursor: 'pointer',
    display: 'block',
    fontSize: 16,
    fontWeight: fonts.weight.medium,
    textAlign: 'center',
    width: '100%',
    ':disabled': {
      opacity: 0.5,
      cursor: 'default',
    },
  }),
  wide: {
    paddingRight: 36,
    paddingLeft: 36,
  },
});

const fontFamilies = StyleSheet.create(fonts.fontFamilyMap);

interface PrimaryButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  text: string;
  buttonId?: string;
  fontFamily?: BlendFontFamily;
  isWide?: boolean;
}

const PrimaryButton = ({
  text,
  buttonId,
  fontFamily = 'Gotham',
  type = 'submit',
  onClick,
  isWide,
  ...htmlProps
}: PrimaryButtonProps) => {
  const handleOnClick = e => _.isFunction(onClick) && onClick(e);

  return (
    <button
      {...htmlProps}
      className={css(styles.base, fontFamilies[fontFamily], isWide && styles.wide)}
      type={type}
      onClick={handleOnClick}
      id={buttonId}
    >
      {text}
    </button>
  );
};

export default PrimaryButton;
